var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativeDetailsDialog", {
        attrs: { viewModel: _vm.alternativeDetailsDialog },
      }),
      _vm._v(" "),
      !_vm.initialized
        ? _c("div", { staticClass: "container" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && _vm.IsClosed
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center",
              staticStyle: { "padding-top": "200px" },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v("Survey is closed"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text lead" }, [
                    _vm._v(
                      "Please wait for the host to open this survey or go to the meeting."
                    ),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.MeetingUrl,
                          expression: "MeetingUrl",
                        },
                      ],
                      staticClass: "btn btn-secondary",
                    },
                    [_vm._v("Go to the meeting")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && !_vm.IsClosed && _vm.SurveyQuestionsCount === 0
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center",
              staticStyle: { "padding-top": "200px" },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v("Empty survey: " + _vm._s(_vm.SurveyName)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text lead" }, [
                    _vm._v(
                      "Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice."
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && !_vm.IsClosed && _vm.SurveyQuestionsCount > 0
        ? _c("div", [
            _c(
              "nav",
              { staticClass: "navbar navbar-expand-md navbar-dark bg-dark" },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "form",
                    { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "sanitizedHref",
                              rawName: "v-sanitizedHref",
                              value: _vm.MeetingUrl,
                              expression: "MeetingUrl",
                            },
                          ],
                          staticClass: "btn btn-light mr-2",
                        },
                        [_vm._v("Join Meeting")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group mr-2",
                          attrs: { role: "group" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            My votes\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.downloadVotes },
                              },
                              [_vm._v("Download to xls")]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c("h3", { staticClass: "mt-5 font-weight-light" }, [
                _vm._v("Survey: " + _vm._s(_vm.SurveyName)),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                Assesss " +
                    _vm._s(_vm.Alternatives.length) +
                    " "
                ),
                _c("span", { staticClass: "text-lowercase" }, [
                  _vm._v(_vm._s(_vm.AlternativesLabel)),
                ]),
                _vm._v(
                  "\n                by answering " +
                    _vm._s(_vm.SurveyQuestionsCount) +
                    " questions.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [
                _vm._v(_vm._s(_vm.SurveyDescription)),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-expand-md navbar-light bg-light",
                },
                [
                  _c(
                    "form",
                    { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.SearchPhrase,
                            expression: "SearchPhrase",
                          },
                        ],
                        staticClass: "form-control mr-sm-2",
                        attrs: { type: "search", placeholder: "Search..." },
                        domProps: { value: _vm.SearchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.SearchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("table", { staticClass: "table table-hover mt-3" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.AlternativeLabel) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _c(
                        "a",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.ToggleOrderByProgressCommand },
                        },
                        [
                          _vm._v(
                            "\n                                Progress\n                            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "120px" } }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.AlternativesView, function (a) {
                    return _c("tr", { key: a.AlternativeId }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            on: {
                              click: function ($event) {
                                return _vm.showAlternativeDetails(a)
                              },
                            },
                          },
                          [_vm._v(_vm._s(a.Name))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "progress",
                            staticStyle: { height: "30px" },
                          },
                          [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: { width: a.Progress + "%" },
                              attrs: { role: "progressbar" },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: a.EvaluationUrl,
                                expression: "a.EvaluationUrl",
                              },
                            ],
                            staticClass: "btn btn-outline-primary",
                          },
                          [_vm._v("Evaluate")]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h3", { staticClass: "text-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Loading..."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-light",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/respondents-scoring",
          title: "Respondents guide: Scoring Projects",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }